import React from 'react';
import { GetStaticProps } from 'next';
import { flatMap, filter, sortBy } from 'lodash';
import { TripTypes } from '@model/contentful';
import { Country, Region } from '@model/common';
import { DestinationPage } from '@model/common/pages/DestinationPage';
import { ContentApi } from '@model/iceberg/service/content';
import { Revalidate } from '@model/config/revalidate';
import { storeWrapper } from '@state/store';
import { DestinationPageHolidaysLayout, DestinationPageHolidaysLayoutProps } from '@layout/DestinationPageLayout';
import { getStaticPropsDestinations } from '@layout/get-page-props';
import { withGlobalProvider } from 'providers/globalProvider';
import { getNameStaticPaths } from '@util/get-static-paths';

const DestinationRegionPageHolidays = (props: DestinationPageHolidaysLayoutProps) => {
  return <DestinationPageHolidaysLayout {...props} />;
};

export const getStaticProps: GetStaticProps = storeWrapper.getStaticProps((store) => async ({ res, params }: any) => ({
  ...(await getStaticPropsDestinations({ store, res, query: params, tripType: TripTypes.HOLIDAYS })),
  revalidate: Revalidate.HALF_HOUR
}));

export async function getStaticPaths() {
  const [continents] = await Promise.all([await new ContentApi().getGeography()]);

  const countries: Array<Country> = flatMap(continents, 'countries');
  const regions: Array<Region> = flatMap(countries, 'regions');

  const destinations = sortBy(filter(regions, 'isSearchable'), 'display');

  const paths = getNameStaticPaths(destinations, DestinationPage.HOLIDAYS);

  return { paths, fallback: false };
}

export default withGlobalProvider(DestinationRegionPageHolidays);
